import {
  Breadcrumbs,
  Card,
  Inline,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { salaryHistoryPath } from '@omnipresentgroup/domains';
import { AddBulkSalaryChangesForm } from '@omnipresentgroup/features';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { HOME_PATH, SALARY_CHANGES_PATH } from '../../../constants';
import { useManagerUser } from '../../../hooks';

const PAGE_TITLE = 'Add salary changes';

export const AddBulkSalaryChanges = () => {
  const companyId = useManagerUser().companyId;

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            { id: 'home', title: 'Home', onClick: () => navigate(HOME_PATH) },
            {
              id: 'salary-changes',
              title: 'Salary changes',
              onClick: () => navigate(SALARY_CHANGES_PATH),
            },
            {
              id: 'add-bulk-salary-changes',
              title: 'Add in bulk',
              active: true,
            },
          ]}
        />
        <Inline
          id="page-header"
          minH={40}
          align="center"
          justify="space-between"
        >
          <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
            {PAGE_TITLE}
          </Typography>
        </Inline>
      </Stack>
      <Inline justify="center">
        <Card p="32" maxW={600} w="stretch">
          <AddBulkSalaryChangesForm
            companyId={companyId}
            onSuccess={() => {
              queryClient.invalidateQueries({
                queryKey: [salaryHistoryPath, companyId],
                refetchType: 'all',
              });
              navigate(SALARY_CHANGES_PATH);
            }}
          />
        </Card>
      </Inline>
    </>
  );
};
